package com.hyperether.planner.model

enum class EventStatus {
    DRAFT,
    OPEN,
    IN_PROGRESS,
    ON_HOLD,
    PENDING_APPROVAL,
    CANCELLED,
    COMPLETED
}